interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  /** What is being switched, for screen readers - the visible text only says On or Off. */
  label: string
  disabled?: boolean
}

/**
 * An on/off control that says which it is. The state is carried three
 * ways - the word, the colour and the knob's side - so it reads at a
 * glance and does not depend on colour alone.
 */
export function Switch({ checked, onChange, label, disabled = false }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`inline-flex items-center gap-2 shrink-0 rounded-full border pl-1 pr-2.5 py-1 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-marine/40 disabled:opacity-50 disabled:cursor-not-allowed ${
        checked ? 'bg-green-lt border-green/50' : 'bg-white border-ink-mid/30'
      }`}
    >
      <span className={`relative w-9 h-5 rounded-full transition-colors ${checked ? 'bg-green' : 'bg-ink-mid/30'}`}>
        <span className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform ${checked ? 'translate-x-4' : 'translate-x-0'}`} />
      </span>
      <span className={`w-6 text-left text-[11px] font-bold ${checked ? 'text-green' : 'text-ink-mid'}`}>{checked ? 'On' : 'Off'}</span>
    </button>
  )
}
